// extracted by mini-css-extract-plugin
export default {"form":"style_form__mTlUL","code":"style_code__p-Xa7","rules":"style_rules__2vjmt","promocode":"style_promocode__4QOud","button":"style_button__dLbLL","resend":"style_resend__rnBpY"};